import React, { useEffect } from "react";
import { useDashboardsrv } from "./useDashboardsrv";
import DashboardPage from "./DashboardPage";
import { t } from "i18next";
import { handleErrorNavigation } from "pages/ErrorPage/ErrorHandler";
import { useNavigate } from 'react-router-dom';
const Dashboard = () => {
  const navigate = useNavigate();
  const { httpgetMemeberBanner } = useDashboardsrv();
  useEffect(() => {
    httpgetMemeberBanner()
      ?.then((res) => {
        console.log("res.data", res.data);
      })
      .catch((e) => {
        handleErrorNavigation(e, navigate, t);
      });
  }, []);
  return (
    <>
      <div>
        <DashboardPage />
      </div>
    </>
  );
};
export default Dashboard;
